import React, { useState } from "react";
import CalculatorCard from "../../components/CalculatorCard";
import PageSeo from "../../components/PageSeo";
import { Helmet } from "react-helmet-async";

export default function ResaleValueCalculator() {
  const [originalPrice, setOriginalPrice] = useState("");
  const [bikeAge, setBikeAge] = useState("");
  const [kms, setKms] = useState("");
  const [condition, setCondition] = useState("1");
  const [resaleValue, setResaleValue] = useState(null);

  const calculateResale = () => {
    const price = Number(originalPrice);
    const age = Number(bikeAge);
    const distance = Number(kms);

    if (!price || age < 0 || distance < 0) return;

    const ageFactor = Math.max(0.3, 1 - age * 0.12);
    const kmFactor = Math.max(0.65, 1 - distance / 100000);

    const value = price * ageFactor * kmFactor * Number(condition);

    setResaleValue(Math.round(value));
  };

  const shareOnWhatsApp = () => {
    const text = encodeURIComponent(`Check my calculation result: Resale Value ₹ ${resaleValue} | MotoHub India https://motohubindia.com`);
    const url = window.innerWidth < 768 
      ? `whatsapp://send?text=${text}` 
      : `https://web.whatsapp.com/send?text=${text}`;
    window.open(url, '_blank');
  };

  const downloadPDF = () => {
    const el = document.getElementById('calculator-result');
    const original = document.title;
    document.title = 'MotoHub-Calculation-Result';
    window.print();
    document.title = original;
  };

  return (
    <>
      <Helmet>
        <title>Used Bike Resale Value Calculator India | MotoHub India</title>
        <meta
          name="description"
          content="Estimate used bike resale value in India. Calculate second-hand motorcycle price based on age, kilometres, and condition."
        />
        <meta
          name="keywords"
          content="bike resale value calculator India, used bike price India, second hand motorcycle valuation, bike depreciation India"
        />
        <link rel="canonical" href="https://motohubindia.com/calculator/resale" />
        <meta property="og:title" content="Bike Resale Value Calculator | MotoHub India" />
        <meta property="og:description" content="Estimate your used bike value easily." />
        <meta property="og:url" content="https://motohubindia.com/calculator/resale" />
      </Helmet>

      <div style={{ padding: "30px" }}>
        <PageSeo
          title="Used Bike Resale Value Calculator India | MotoHub"
          description="Estimate second hand bike price easily."
          path="/calculator/resale"
        />

        <CalculatorCard title="Resale Value Calculator">
          <div style={seoBox}>
            <h2>Used Bike Resale Value Calculator India</h2>
            <p style={seoText}>
              Use MotoHub India resale calculator to estimate the market value of your used motorcycle. 
              Enter original price, bike age, kilometres ridden, and condition to get an approximate resale price.
            </p>
            <p style={seoText}>
              This tool helps bike owners understand depreciation and make better decisions when selling or upgrading their bike.
            </p>
          </div>

          <input
            placeholder="Original purchase price (Rs)"
            value={originalPrice}
            onChange={(e) => setOriginalPrice(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="Bike age (years)"
            value={bikeAge}
            onChange={(e) => setBikeAge(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="Kilometres ridden"
            value={kms}
            onChange={(e) => setKms(e.target.value)}
            style={inputStyle}
          />

          <select
            value={condition}
            onChange={(e) => setCondition(e.target.value)}
            style={inputStyle}
          >
            <option value="1">Excellent condition</option>
            <option value="0.9">Good condition</option>
            <option value="0.8">Average condition</option>
            <option value="0.68">Needs work</option>
          </select>

          <button style={buttonStyle} onClick={calculateResale}>
            Estimate Resale Value
          </button>

          <div id="calculator-result">
            {resaleValue && (
              <>
                <h3 style={{ marginTop: "20px" }}>
                  Estimated Resale Value: ₹ {resaleValue.toLocaleString("en-IN")}
                </h3>
                <p style={noteStyle}>
                  This is an estimated market value. Final price depends on brand demand, service history, and location.
                </p>
                <button onClick={shareOnWhatsApp} 
                  className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm">
                  Share on WhatsApp
                </button>
                <button onClick={downloadPDF}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm">
                  Download PDF
                </button>
              </>
            )}
          </div>
        </CalculatorCard>
      </div>
    </>
  );
}

// Styles
const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "10px",
  borderRadius: "10px",
  border: "1px solid #333",
  background: "#1a1a1a",
  color: "#fff",
};

const buttonStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "10px",
  border: "none",
  background: "linear-gradient(90deg, #ff4d00, #ff7a00)",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
};

const noteStyle = {
  marginTop: "14px",
  color: "#aaa",
  lineHeight: 1.6,
  fontSize: "14px",
};

const seoBox = {
  marginBottom: "20px",
  background: "#111",
  padding: "15px",
  borderRadius: "10px",
  border: "1px solid #222",
};

const seoText = {
  color: "#aaa",
  lineHeight: "1.6",
  marginTop: "8px",
};